import { render, staticRenderFns } from "./projectDetails.vue?vue&type=template&id=18197a5d&"
import script from "./projectDetails.vue?vue&type=script&lang=js&"
export * from "./projectDetails.vue?vue&type=script&lang=js&"
import style0 from "./projectDetails.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports